import React from "react";

import ReactHtmlParser from "react-html-parser";
import { animated, useTransition, config } from "react-spring";

const Question = props => {
  // deconstruct objects
  const { item = [] } = props;
  const { content } = item;

  const transitions = useTransition(content, null, {
    /*     
    from: {opacity: 0,marginLeft: -40},
    enter: { opacity: 1, marginLeft: 0 },
    leave: { marginTop: -40, position: "absolute" } 
    */
    from: { opacity: 0, transform: "translate3d(-40px,0 ,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
    leave: { marginTop: -40 },
    config: config.slow
  });
  return transitions.map(({ item, key, props }) => (
    <animated.div key={key} style={props}>
      <div className="question-wrapper">{ReactHtmlParser(item)}</div>
    </animated.div>
  ));
};

export default Question;
